import { render } from "./SearchMember.vue?vue&type=template&id=7b671531"
import script from "./SearchMember.vue?vue&type=script&lang=js"
export * from "./SearchMember.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__